import React from 'react';
import PropTypes from 'prop-types';
import TitleLink from '../TitleLink/TitleLink'; // Import the TitleLink component
import Thumbnail from '../Thumbnail/Thumbnail'; // Import the Thumbnail component
import ResultContainer from '../ResultContainer/ResultContainer'; // Import the ResultContainer component

import './SuiResult.css';

const SuiResult = ({ result, cleanTitle, onClickLink, decodeHtmlEntities }) => {
  const url = result.url?.raw || '';
  //const fileType = result.file_type?.raw || '';

  return (
    <li className="sui-result">
      <div style={{ marginBottom: '0px' }}>
        <TitleLink 
          url={url}     
          cleanTitle={cleanTitle} 
          onClickLink={onClickLink} 
        />

      </div>
      <div 
        className="sui-result__header" 
        style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          justifyContent: 'center',
          paddingTop: '10px'
        }}
      >
        <Thumbnail displayThumbnail={result.thumbnail?.raw || ''} />
        <ResultContainer 
          result={result} 
          decodeHtmlEntities={decodeHtmlEntities} 
          onClickLink={onClickLink} 
        />
      </div>
    </li>
  );
};

SuiResult.propTypes = {
  result: PropTypes.object.isRequired,
  cleanTitle: PropTypes.string.isRequired,
  onClickLink: PropTypes.func.isRequired,
  decodeHtmlEntities: PropTypes.bool.isRequired,
};

export default SuiResult;
